import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useDeleteRiskObservationDialogDataMapping } from "./DeleteRiskObservationDialog.hooks";

export interface IDeleteRiskObservationDialog {
    onCloseDialog: () => void;
    onDeletion: () => void;
    observationId: string;
    observationName: string;
}

export function DeleteRiskObservationDialog(props: IDeleteRiskObservationDialog) {
    const { removeObservation, inProgress } = useDeleteRiskObservationDialogDataMapping(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.observationName}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeObservation}
            inProgress={inProgress}
        />
    );
}
